export default function LogoCard({
  logo,
  onFinalize,
  onRefine,
}) {
  return (
    <div
      className="relative group rounded-2xl overflow-hidden border border-slate-200 dark:border-white/10 bg-white/5 dark:bg-white/[0.03] hover:bg-white/10 dark:hover:bg-white/[0.05] hover:border-violet-400/40 transition-all duration-300 cursor-pointer w-full aspect-square hover:scale-[1.02] hover:shadow-2xl hover:shadow-violet-500/10"
      onClick={() => onFinalize(logo.id)}
    >
      <div className="h-full flex items-center justify-center p-4">
        {logo.url ? (
          <img
            src={logo.url}
            alt={`Icon option ${logo.id}`}
            className="w-full h-full object-contain drop-shadow-sm group-hover:drop-shadow-md transition-all duration-300"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-violet-500/5 to-fuchsia-500/5 flex items-center justify-center rounded-xl border border-slate-200 dark:border-white/5">
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto mb-2 bg-gradient-to-br from-violet-500 to-fuchsia-500 rounded-2xl flex items-center justify-center shadow-[0_16px_30px_-20px_rgba(168,85,247,0.70)] border border-slate-200 dark:border-white/10 group-hover:scale-110 transition-transform duration-300">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"
                  />
                </svg>
              </div>
              <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400 group-hover:text-violet-400 transition-colors">Draft Option</p>
            </div>
          </div>
        )}
      </div>

      {/* Hover overlay with actions */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-4 transition-opacity duration-300 opacity-0 group-hover:opacity-100">
        <div className="flex gap-3 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRefine(logo.id);
            }}
            className="flex-1 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 text-white rounded-xl py-2.5 text-xs font-bold transition-all hover:scale-105 active:scale-95"
          >
            Refine
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onFinalize(logo.id);
            }}
            className="flex-1 bg-gradient-to-r from-violet-500 to-fuchsia-500 hover:from-violet-400 hover:to-fuchsia-400 text-white rounded-xl py-2.5 text-xs font-bold transition-all hover:scale-105 active:scale-95 shadow-lg shadow-violet-500/25"
          >
            Finalize
          </button>
        </div>
      </div>

      {/* Option number badge */}
    </div>
  );
}

